<template>
  <div>
    <site-header />
    <main class="policy-page">
      <section class="page-heading policy-hero">
        <p>Customer Care</p>
        <h1>Accessibility Statement</h1>
        <span>Our commitment to making site content accessible, usable, and inclusive for everyone.</span>
      </section>

      <section class="shipping-policy">
        <div class="policy-grid">
          <article>
            <h3>Accessibility Commitment</h3>
            <p>We are committed to making website content accessible and user friendly for all visitors, including people with disabilities.</p>
          </article>
          <article>
            <h3>Ongoing Improvements</h3>
            <p>We continually evaluate ways to improve site navigation, content structure, features, and functionality so more customers can use the site comfortably.</p>
          </article>
          <article>
            <h3>Feedback</h3>
            <p>If you have difficulty viewing or navigating content, or notice a feature that may not be fully accessible, please share a description of the issue and any suggested improvement through customer service.</p>
          </article>
          <article>
            <h3>Third-Party Content</h3>
            <p>Some digital content may be provided by third parties. While such content is not directly controlled by this site, third-party providers are encouraged to make their content accessible and user friendly.</p>
          </article>
        </div>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'AccessibilityStatement',
  components: { SiteHeader, SiteFooter }
}
</script>
